export default __webpack_public_path__ + "static/media/Xmark.16ffcbe7.svg";